import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LoginPage, RegisterPage, InvitePage } from "@/components/Auth";
import Workspace from "@/components/Workspace";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="h-screen flex items-center justify-center text-muted-foreground">
        Loading library…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function InviteRoute() {
  const { token } = useParams();
  return <InvitePage token={token} />;
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/invite/:token" element={<InviteRoute />} />
            <Route
              path="/*"
              element={
                <Protected>
                  <Workspace />
                </Protected>
              }
            />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
